export default "__VITE_ASSET__03f71934__"